var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833313 1.33317C0.833313 0.964981 1.13179 0.666504 1.49998 0.666504H13.5C13.8682 0.666504 14.1666 0.964981 14.1666 1.33317V14.6665C14.1666 15.0347 13.8682 15.3332 13.5 15.3332H1.49998C1.13179 15.3332 0.833313 15.0347 0.833313 14.6665V1.33317ZM2.16665 1.99984V13.9998H12.8333V1.99984H2.16665ZM10.8333 11.9998H4.16665V10.6665H10.8333V11.9998ZM4.83331 3.99984C4.46512 3.99984 4.16665 4.29831 4.16665 4.6665V7.99984C4.16665 8.36803 4.46512 8.6665 4.83331 8.6665H10.1666C10.5348 8.6665 10.8333 8.36803 10.8333 7.99984V4.6665C10.8333 4.29831 10.5348 3.99984 10.1666 3.99984H4.83331ZM5.49998 7.33317V5.33317H9.49998V7.33317H5.49998Z",
    fill: "#585C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.c080b9a5.svg";
export { ForwardRef as ReactComponent };